import { connect } from 'react-redux';
import CashSummaryUI from './CashSummaryUI';
import { selectors } from '@makemydeal/dr-offer-redux';
import { isValidDollarAmount, formatDollars } from '../../utils/formatUtils';
import { getVehicleRetailPrice } from './selectors';

export const mapStateToProps = (state, ownProps) => {
    const offer = selectors.getOfferDetails(state, 'cash');
    const { vehicle } = selectors.getVehicleSinglePriceData(state);
    const vehicleCondition = vehicle.condition;
    const dealerFees = offer.dealerFees;
    const dealerFeesTotal = offer.dealerFeesTotal;
    let special = null;
    if (offer.totalIncentives > 0) {
        special = formatDollars(offer.totalIncentives);
    }
    const initialOfferPrice = offer.initialOfferPrice;
    const totalTax = offer.totalTax > 0 ? offer.totalTax : null;
    const dmvFees = offer.dmvFees;
    const tradeValue = selectors.getTradeInValue(state);
    const tradeAmtOwed = selectors.getTradeInAmountOwed(state);
    const netTradeIn = isNaN(tradeValue - tradeAmtOwed) ? null : tradeValue - tradeAmtOwed;
    const offerPrice = isValidDollarAmount(offer.offerPrice) ? offer.offerPrice : null;
    const absoluteTradeIn = netTradeIn > 0 ? netTradeIn : -1 * netTradeIn;
    const formattedNetTradeIn = isValidDollarAmount(absoluteTradeIn) ? formatDollars(absoluteTradeIn) : null;
    const tradeInWithSign = netTradeIn > 0 ? `-${formattedNetTradeIn}` : formattedNetTradeIn;
    const isSinglePrice = selectors.isVehicleSinglePrice(state);
    const cashOffer = selectors.getCashTotalAmountDueAfterCredits(state);
    const retailPrice = getVehicleRetailPrice(state);

    return {
        isSinglePrice,
        tradeValue,
        tradeInWithSign,
        vehicle,
        cashOffer,
        offerPrice,
        vehicleCondition,
        dealerFees,
        dealerFeesTotal,
        initialOfferPrice,
        totalTax,
        dmvFees,
        retailPrice,
        special,
        advertisedPriceLabel: (ownProps && ownProps.advertisedPriceLabel) || null
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

const CashSummary = connect(mapStateToProps, mapDispatchToProps)(CashSummaryUI);

export default CashSummary;
